import React from "react";
import "./CommonTabsPanel.sass"

export default function Tab(props) {
    const {children, value, index, onClick, style} = props;

    return (
        <div className={"common-tab-wrapper" + (value === index ? " common-tab-wrapper-active" : "")}
             style={style || {}}
             onClick={() => onClick(index)}>
            {children}
        </div>
    )
}
